import {
  ActionTypes,
  VideoLibraryDataTableActionTypes,
} from "../Constants/ActionTypes";

const initialState = {
  isEditFilter: false,
  filterList: [],
  appliedFilterList: [],
  filterValues: [],
  addFilterPopUp: false,
  filterData: null,
  loading: {
    pageLoading: false,
    buttonLoading: false,
  },
};

export const VideoLibraryFilterReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_VIDEO_LIBRARY_FILTER_LIST:
      return {
        ...state,
        filterList: payload,
      };

    case ActionTypes.DELETE_FILTER:
      return {
        ...state,
        filterList: state.filterList.filter((item) => item.id != payload.id),
      };

    case ActionTypes.SET_EDIT_FILTER:
      return {
        ...state,
        isEditFilter: payload,
      };

    case ActionTypes.SET_EDIT_FILTER_INFORMATION:
      return {
        ...state,
        filterData: payload,
      };

    case ActionTypes.OPEN_ADD_FILTER_POPUP:
      return {
        ...state,
        addFilterPopUp: payload,
      };

    case ActionTypes.FILTER_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          pageLoading: payload.pageLoading,
          buttonLoading: payload.buttonLoading,
        },
      };

    case ActionTypes.ADD_NEW_FILTER:
      return {
        ...state,
        filterList: [payload, ...state.filterList],
      };

    case ActionTypes.UPDATE_FILTER:
      return {
        ...state,
        filterList: state.filterList.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    case VideoLibraryDataTableActionTypes.APPLIED_FILTER_LIST:
      return {
        ...state,
        appliedFilterList: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_FILTER_VALUES:
      return {
        ...state,
        filterValues: payload,
      };

    default:
      return state;
  }
};
